import { message } from 'antd';
import { FileItem } from 'common/components/resourceUpload/UploadButton';

export const PAGE_SIZE = 40;
export const FILE_LIMIT = 1024; // 单位 MB, 目前文件最大限制1G（2019/4/29和tinny确认）

export const FILE_TYPE_REGEXP = {
  image: /(png|jpg|jpeg)$/i,
  video: /(mp4)$/i,
  audio: /(mp3|wav)$/i,
  document: /(pdf|doc|docx|ppt|pptx|xls|xlsx|srt|lrc)$/i,
  animation: /zip$/i,
};

export function fileFilter(files: FileList, reg: RegExp, maxSize?: number) {
  const uploadFiles: FileItem[] = [];

  for (let i = 0, len = files.length; i < len; i++) {
    const file = files[i];
    if (!reg.test(file.name)) {
      message.error('文件格式不正确, 文件名: ' + file.name);
      continue;
    }
    if (maxSize && file.size > maxSize) {
      message.error(`文件大小超出限制(${maxSize / 1024 / 1024}MB), 文件名: ` + file.name);
      continue;
    }
    uploadFiles.push({
      file,
      name: file.name,
      id: Math.random().toString(36).substring(3),
    });
  }

  return uploadFiles;
}

export const getFileTypeByFormat = (inFormat) => {
  let res = 'unknown';
  nx.forIn(FILE_TYPE_REGEXP, (key, value) => {
    if (value.test(inFormat)) {
      res = key;
      return nx.BREAKER;
    }
  });
  return res;
};
